import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Check, Minus, ArrowLeft } from "lucide-react";
import PublicHeader from "@/components/layout/PublicHeader";
import PublicFooter from "@/components/layout/PublicFooter";
import { Button } from "@/components/ui/button";

// value: true | false | string ("+€800/mã", "gia hạn add-on", …)
const ROWS = [
  { section: { vi: "THIẾT LẬP", en: "SETUP" } },
  { label: { vi: "Đăng ký chi nhánh EU tại Phần Lan (mặc định)", en: "EU branch registration in Finland (default)" },
    values: [true, true, true] },
  { label: { vi: "Thành lập công ty Oy độc lập (tuỳ chọn)",         en: "Stand-alone Finnish Oy (optional)" },
    values: [{ vi: "Theo yêu cầu", en: "On request" }, { vi: "Theo yêu cầu", en: "On request" }, { vi: "Theo yêu cầu", en: "On request" }] },
  { label: { vi: "Nominee director cho Oy (nếu chọn Oy)",   en: "Nominee director for Oy (if chosen)" },
    values: [{ vi: "Liên hệ", en: "On request" }, { vi: "Liên hệ", en: "On request" }, { vi: "Liên hệ", en: "On request" }] },
  { label: { vi: "Hỗ trợ quyền cư trú founder (nếu chọn Oy)", en: "Founder residency sponsorship (if Oy chosen)" },
    values: [{ vi: "Phí riêng · theo diện cư trú", en: "Separate · per permit track" }, { vi: "Phí riêng · theo diện cư trú", en: "Separate · per permit track" }, { vi: "Phí riêng · theo diện cư trú", en: "Separate · per permit track" }] },
  { label: { vi: "Đăng ký mã số doanh nghiệp (y-tunnus)",  en: "Business ID (y-tunnus) registration" },       values: [true, true, true] },
  { label: { vi: "Đăng ký thuế VAT toàn EU (OSS)",          en: "EU-wide VAT (OSS) registration" },              values: [true, true, true] },
  { label: { vi: "Mở tài khoản IBAN tại Phần Lan",           en: "Finnish IBAN account (partner bank)" },        values: [true, true, true] },

  { section: { vi: "TUÂN THỦ EU", en: "EU COMPLIANCE" } },
  { label: { vi: "Rà soát nhãn hàng + mã HS (3 mã đầu)",    en: "Label review + HS classification (first 3 SKUs)" },
    values: [{ vi: "Liên hệ", en: "On request" }, true, true] },
  { label: { vi: "Rà soát nhãn hàng + mã HS bổ sung (từ SKU 4)", en: "Extra label + HS review (from SKU 4)" },
    values: [{ vi: "Liên hệ", en: "On request" }, { vi: "Liên hệ", en: "On request" }, { vi: "Liên hệ", en: "On request" }] },
  { label: { vi: "Giấy phép EU đầu tiên (bao gồm)",           en: "First EU licence (included)" },
    values: [{ vi: "Liên hệ", en: "On request" }, true, true] },
  { label: { vi: "Giấy phép EU bổ sung (tính riêng)",         en: "Additional EU licences (billed separately)" },
    values: [{ vi: "Liên hệ", en: "On request" }, { vi: "Liên hệ", en: "On request" }, { vi: "Liên hệ", en: "On request" }] },

  { section: { vi: "KHO HELSINKI", en: "HELSINKI WAREHOUSE" } },
  { label: { vi: "Vị trí kho Helsinki + phần mềm theo dõi", en: "Helsinki warehouse slot + stock dashboard" },
    values: [{ vi: "Add-on · Liên hệ", en: "Add-on · On request" }, { vi: "Add-on · Liên hệ", en: "Add-on · On request" }, { vi: "Miễn phí 3 tháng đầu, sau đó tính phí thành viên kho", en: "3 months free, then warehouse membership fee applies" }] },
  { label: { vi: "Bao gồm số pallet",                        en: "Pallets included" },
    values: [{ vi: "5 pallet", en: "5 pallets" }, { vi: "5 pallet", en: "5 pallets" }, { vi: "5 pallet", en: "5 pallets" }] },
  { label: { vi: "Pallet vượt định mức",                     en: "Extra pallets" },
    values: [{ vi: "Phí bổ sung/pallet", en: "Add-on per pallet" }, { vi: "Phí bổ sung/pallet", en: "Add-on per pallet" }, { vi: "Phí bổ sung/pallet", en: "Add-on per pallet" }] },
  { label: { vi: "Thông quan lô hàng đầu tiên + nhập kho",   en: "First-shipment customs clearance + intake" },   values: [false, false, true] },
  { label: { vi: "Xử lý và giao đơn hàng khắp EU",           en: "EU-wide order fulfilment" },                     values: [false, false, true] },

  { section: { vi: "THƯƠNG HIỆU & GIAN HÀNG", en: "BRAND & STOREFRONT" } },
  { label: { vi: "Đăng ký nhãn hiệu EU (EUIPO)",             en: "EU trademark filing (EUIPO)" },
    values: [{ vi: "Add-on · Liên hệ", en: "Add-on · On request" }, { vi: "Add-on · Liên hệ", en: "Add-on · On request" }, { vi: "Bao gồm ✓", en: "Included ✓" }] },
  { label: { vi: "Thiết lập gian hàng trên Safeway Finland",    en: "Storefront setup on Safeway Finland" },
    values: [false, false, true] },

  { section: { vi: "CHUYÊN VIÊN PHỤ TRÁCH", en: "ACCOUNT MANAGER" } },
  { label: { vi: "Thời gian và cường độ",                    en: "Duration and intensity" },
    values: [
      { vi: "1 giờ tư vấn khởi động", en: "1h kick-off consulting" },
      { vi: "3 tháng · 1-2 gọi/tuần", en: "3 months · 1-2 calls/week" },
      { vi: "12 tháng · WhatsApp trực tiếp · phản hồi 4 giờ", en: "12 months · direct WhatsApp · 4h SLA" },
    ] },

  { section: { vi: "HOA HỒNG", en: "COMMISSION" } },
  { label: { vi: "Hoa hồng trên đơn hàng EU đi từ kho",       en: "Commission on EU orders shipped from warehouse" },
    values: [
      { vi: "Liên hệ (nếu dùng kho + sàn)", en: "On request (if using warehouse + marketplace)" },
      { vi: "Liên hệ (nếu dùng kho + sàn)", en: "On request (if using warehouse + marketplace)" },
      { vi: "Liên hệ · chỉ khi bán được", en: "On request · pay-as-you-sell" },
    ] },
];

const TIERS = [
  { id: "incorporate", price: "Liên hệ", tag: { vi: "Một lần", en: "One-time" } },
  { id: "setup",        price: "Liên hệ", tag: { vi: "Một lần", en: "One-time" } },
  { id: "turnkey",      price: "Liên hệ", tag: { vi: "Một lần · đề xuất", en: "One-time · Recommended" }, highlight: true },
];

const RenderCell = ({ value, lang }) => {
  if (value === true) return <Check className="w-5 h-5 text-primary mx-auto" />;
  if (value === false) return <Minus className="w-5 h-5 text-muted-foreground/40 mx-auto" />;
  if (typeof value === "object" && value !== null) return <span className="text-sm">{value[lang] || value.en}</span>;
  return <span className="text-sm">{value}</span>;
};

export default function PackagesDetails() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("vi") ? "vi" : "en";
  const vi = lang === "vi";

  return (
    <div data-testid="packages-details-page" className="min-h-screen bg-background">
      <PublicHeader />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <Link to="/packages" data-testid="back-to-packages" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary mb-6">
          <ArrowLeft className="w-4 h-4" /> {vi ? "Quay lại trang Gói dịch vụ" : "Back to Packages"}
        </Link>
        <div className="overline text-primary mb-4">{vi ? "SO SÁNH CHI TIẾT" : "DETAILED COMPARISON"}</div>
        <h1 className="font-heading text-4xl md:text-5xl font-black tracking-tight text-secondary leading-tight max-w-3xl">
          {vi ? "Ba gói, một bảng — biết chính xác bạn nhận gì." : "Three packages, one table — know exactly what you get."}
        </h1>
        <p className="mt-4 text-muted-foreground leading-relaxed max-w-2xl">
          {vi
            ? "Bảng bên dưới liệt kê từng dịch vụ trong 3 gói setup và những khoản phụ thu nếu vượt định mức. Không có in đậm ẩn trong hợp đồng."
            : "The table below lists every service in our 3 setup packages, plus any surcharges once you exceed the included limits. No fine print, no surprises."}
        </p>
        <div className="mt-6 rounded-md border border-primary/40 bg-primary/5 p-4 max-w-3xl text-sm text-secondary" data-testid="finnish-law-note">
          <strong>{vi ? "Cấu trúc pháp lý: " : "Legal structure: "}</strong>
          {vi
            ? "Mặc định chúng tôi đăng ký chi nhánh EU cho quý doanh nghiệp — không cần nominee director, không phát sinh phí duy trì. Nếu quý doanh nghiệp muốn thành lập công ty Oy độc lập, luật Phần Lan yêu cầu có nominee director ngay từ ngày đầu (chi phí trọn gói/năm, vui lòng liên hệ để trao đổi). Khách chọn Oy cũng có thể xin giấy phép cư trú diện Doanh nhân hoặc Startup cho founder — phí riêng theo diện, vui lòng xem trang chương trình định cư."
            : "By default we register an EU branch — no nominee director needed, no recurring fee. If you'd like a stand-alone Finnish Oy, Finnish law requires a nominee director starting day 1 (annual retainer, please contact us for details). Oy clients can additionally apply for Entrepreneur Permit or Startup Permit residency for their founder — separate fees per track, see the residence permit page for details."}
        </div>

        <div className="mt-12 overflow-x-auto border border-border rounded-lg" data-testid="comparison-table">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-muted/50">
                <th className="text-left p-4 font-heading font-bold text-secondary w-1/3">{vi ? "Dịch vụ" : "Service"}</th>
                {TIERS.map((tier) => (
                  <th key={tier.id} className={`p-4 text-center ${tier.highlight ? "bg-secondary text-secondary-foreground" : ""}`}>
                    <div className="font-heading text-lg font-bold">{t(`mkt.packages.${tier.id}.name`)}</div>
                    <div className={`font-heading text-2xl font-black mt-1 ${tier.highlight ? "text-primary" : "text-secondary"}`}>{tier.price}</div>
                    <div className={`text-xs ${tier.highlight ? "text-secondary-foreground/60" : "text-muted-foreground"}`}>{tier.tag[lang]}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, i) => {
                if (row.section) {
                  return (
                    <tr key={`sec-${i}`} data-testid={`section-${i}`} className="bg-primary/5">
                      <td colSpan={4} className="px-4 py-3">
                        <div className="overline text-primary text-[10px]">{typeof row.section === "object" ? row.section[lang] : row.section}</div>
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr key={`row-${i}`} className="border-t border-border">
                    <td className="p-4 text-secondary font-medium">{row.label[lang]}</td>
                    {row.values.map((v, ci) => (
                      <td key={ci} className="p-4 text-center align-middle">
                        <RenderCell value={v} lang={lang} />
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/contact"><Button size="lg" className="h-12 px-8">{vi ? "Trao đổi với chúng tôi" : "Talk to our team"}</Button></Link>
          <Link to="/packages"><Button size="lg" variant="outline" className="h-12 px-8">{vi ? "Xem lại 3 gói" : "Back to packages"}</Button></Link>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
